
import React from 'react';



export default class JumperElement extends React.Component{

    constructor(props){
        super(props)


    }
    createElements() {
        let code=<>{this.props.codes}</>
        return {__html: code};
      }
    render(){
        // let prop=this.props.codes
        // let codes=this.createElements()
        var Response = <div dangerouslySetInnerHTML={{__html: this.props.codes}}></div>
        return(
            <>
                {Response}
            </>
        )
    }
}